import React, { Component, Fragment } from 'react';

import classnames from 'classnames';
import _ from 'lodash';

import ColorPicker from 'components/ColorPicker';
import StylesRadioImage from 'components/StylesRadioImage';
import ButtonBorderChanger from 'components/ButtonBorderChanger';
import LinearGradientButton from 'components/LinearGradientButton';

import bgImgStyle1 from 'images/bg-img-style1.svg';

const SUBMIT_DELAY = 500;

class ButtonStyles extends Component {
  acceptButtonStyles = (id, value, type, typeValue) => {
    const { acceptButtonStyles } = this.props;
    let body = {};
    body[id] = value;
    if (type) {
      body[type] = typeValue;
    }

    acceptButtonStyles(body);
  };

  handleDebounce = _.debounce((id, value) => {
    this.acceptButtonStyles(id, value);
  }, SUBMIT_DELAY);

  render() {
    const { styles } = this.props;
    const { defaultButtonValues } = this.props;
    let palette;
    if (defaultButtonValues.background_type === 'gradient') {
      palette = _.get(defaultButtonValues, 'background_value', false)
        ? _.get(defaultButtonValues, 'background_value', false)
            .split(', ')
            .map(el => {
              return {
                pos: parseInt(el.split(' ')[1].slice(0, -1)) / 100,
                color: el.split(' ')[0],
              };
            })
        : false;
    } else {
      palette = false;
    }
    return (
      <Fragment>
        <h2 className="h2-title">Button</h2>
        <div className="separator-line m-b-40" />
        <div className="style-form m-b-50">
          <div className="style-form__row">
            <div className="style-form__col bg flex">
              <div className="style-form__subtitle top">Button background</div>
              <div className="bg-images-group">
                <StylesRadioImage
                  src={bgImgStyle1}
                  htmlFor="background_value"
                  labelClassName={classnames('bg-image-itm__label', {
                    'bg-image-itm__label__checked':
                      defaultButtonValues.background_type === null,
                  })}
                  radioName="background-overlay-style"
                  radioClassName="bg-image-itm__input invisible"
                  alt="image99"
                  onChange={() =>
                    this.acceptButtonStyles(
                      'background_value',
                      null,
                      'background_type',
                      null,
                    )
                  }
                  checked={defaultButtonValues.background_value === null}
                />
                <div className="bg-image-itm">
                  <label
                    className={classnames('bg-image-itm__label', {
                      'bg-image-itm__label__checked':
                        defaultButtonValues.background_type === 'color',
                    })}>
                    <ColorPicker
                      color={defaultButtonValues.background_value}
                      acceptColor={color =>
                        this.acceptButtonStyles(
                          'background_value',
                          color,
                          'background_type',
                          'color',
                        )
                      }
                    />
                  </label>
                </div>
                <div className="bg-image-itm">
                  <label
                    className={classnames('bg-image-itm__label', {
                      'bg-image-itm__label__checked':
                        defaultButtonValues.background_type === 'gradient',
                    })}
                    style={{
                      background:
                        'linear-gradient(rgb(249, 237, 50) 0%, rgb(238, 42, 123) 60%, rgb(64, 106, 255) 100%)',
                    }}>
                    <LinearGradientButton
                      color={defaultButtonValues}
                      styles={styles}
                      palette={palette}
                      acceptColor={color =>
                        this.acceptButtonStyles(
                          'background_value',
                          color,
                          'background_type',
                          'gradient',
                        )
                      }
                    />
                  </label>
                </div>
              </div>
            </div>
            <div className="style-form__col bg flex">
              <div className="style-form__subtitle top">Button text</div>
              <div className="bg-images-group">
                <div className="bg-image-itm">
                  <label
                    className={classnames('bg-image-itm__label', {
                      'bg-image-itm__label__checked':
                        defaultButtonValues.text_type === 'color',
                    })}>
                    <ColorPicker
                      color={defaultButtonValues.text_value}
                      acceptColor={color =>
                        this.acceptButtonStyles(
                          'text_value',
                          color,
                          'text_type',
                          'color',
                        )
                      }
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="style-form__row">
            <div className="style-form__col bg flex">
              <div className="style-form__subtitle top">Button border</div>
              <div className="bg-images-group">
                <div className="bg-image-itm">
                  <label
                    className={classnames('bg-image-itm__label', {
                      'bg-image-itm__label__checked':
                        defaultButtonValues.border_type === 'color',
                    })}>
                    <ColorPicker
                      color={defaultButtonValues.border_value}
                      acceptColor={color =>
                        this.acceptButtonStyles(
                          'border_value',
                          color,
                          'border_type',
                          'color',
                        )
                      }
                    />
                  </label>
                </div>
              </div>
            </div>
            <div className="style-form__col bg flex">
              <div className="style-form__subtitle top">Button glow</div>
              <div className="bg-images-group">
                <StylesRadioImage
                  src={bgImgStyle1}
                  htmlFor="glow_value"
                  labelClassName={classnames('bg-image-itm__label', {
                    'bg-image-itm__label__checked':
                      defaultButtonValues.glow_type === null,
                  })}
                  radioName="background-overlay-style"
                  radioClassName="bg-image-itm__input invisible"
                  alt="image99"
                  onChange={() =>
                    this.acceptButtonStyles(
                      'glow_value',
                      null,
                      'glow_type',
                      null,
                    )
                  }
                  checked={defaultButtonValues.glow_value === null}
                />
                <div className="bg-image-itm">
                  <label
                    className={classnames('bg-image-itm__label', {
                      'bg-image-itm__label__checked':
                        defaultButtonValues.glow_type === 'color',
                    })}>
                    <ColorPicker
                      color={defaultButtonValues.glow_value}
                      acceptColor={color =>
                        this.acceptButtonStyles(
                          'glow_value',
                          color,
                          'glow_type',
                          'color',
                        )
                      }
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="style-form__row">
            <ButtonBorderChanger
              header="Button border thickness"
              defaultValue={defaultButtonValues.border_thickness}
              handleChange={value =>
                this.handleDebounce('border_thickness', value)
              }
              min={1}
              max={10}
            />
            <ButtonBorderChanger
              header="Button border radius"
              defaultValue={defaultButtonValues.border_radius}
              handleChange={value =>
                this.handleDebounce('border_radius', value)
              }
              min={1}
              max={10}
            />
          </div>
          <div className="style-form__row">
            <div className="style-form__col bg flex">
              <div className="style-form__subtitle top">Hover</div>
              <div className="bg-images-group">
                <StylesRadioImage
                  src={bgImgStyle1}
                  htmlFor="hover_value"
                  labelClassName={classnames('bg-image-itm__label', {
                    'bg-image-itm__label__checked':
                      defaultButtonValues.hover_type === null,
                  })}
                  radioName="background-overlay-style"
                  radioClassName="bg-image-itm__input invisible"
                  alt="image99"
                  onChange={() =>
                    this.acceptButtonStyles(
                      'hover_value',
                      null,
                      'hover_type',
                      null,
                    )
                  }
                  checked={defaultButtonValues.hover_type === null}
                />
                <div className="bg-image-itm">
                  <label
                    className={classnames('bg-image-itm__label', {
                      'bg-image-itm__label__checked':
                        defaultButtonValues.hover_type === 'color',
                    })}>
                    <ColorPicker
                      color={defaultButtonValues.hover_value}
                      acceptColor={color =>
                        this.acceptButtonStyles(
                          'hover_value',
                          color,
                          'hover_type',
                          'color',
                        )
                      }
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ButtonStyles;



// WEBPACK FOOTER //
// ./src/scenes/Styles/ButtonStyles.js